import GoogleMapsLoader from 'google-maps';

const googleMapsKey = process.env.VUE_APP_GOOGLE_MAPS_KEY || 'AIzaSyDEwgDw6WdbulMvStiRgWzgYVAaOXbrFMc';
const googleMapsClient = process.env.VUE_APP_GOOGLE_MAPS_CLIENT || 'gme-falabellaecommerce';

GoogleMapsLoader.VERSION = process.env.VUE_APP_GOOGLE_MAPS_VERSION || 3.39;
GoogleMapsLoader.LANGUAGE = process.env.VUE_APP_GOOGLE_MAPS_LANGUAGE || 'ES';
GoogleMapsLoader.REGION = process.env.VUE_APP_GOOGLE_MAPS_REGION || 'CL';
GoogleMapsLoader.LIBRARIES = (process.env.VUE_APP_GOOGLE_MAPS_LIBRARIES || 'places,drawing,visualization')
  .split(',')
  .map(value => value.trim())
  .filter(Boolean);
GoogleMapsLoader.CHANNEL = process.env.VUE_APP_GOOGLE_MAPS_CHANNEL || 'geosort_web';

if (googleMapsKey) {
  GoogleMapsLoader.KEY = googleMapsKey;
} else if (googleMapsClient) {
  GoogleMapsLoader.CLIENT = googleMapsClient;
}

const SafeGoogleMapsLoader = {
  ...GoogleMapsLoader,
  load(callback) {
    if (window.google && window.google.maps) {
      callback(window.google);
      return;
    }

    GoogleMapsLoader.load(callback);
  },
};

export default SafeGoogleMapsLoader;
